<template>
  <div class="history">
    <div class="container-xl py-4 report-container">
      <b-button size="sm" variant="outline-danger" @click="backToDashboard" class="mb-3">
        <i class="bi bi-arrow-left mr-1"></i>
        Quay lại
      </b-button>

      <!-- FILTER -->
      <div class="filter-card mb-4">
        <div class="row g-3 align-items-end">
          <div class="col-xl-3 col-lg-4 col-md-6">
            <label class="form-label fw-bold">
              <i class="bi bi-calendar-event text-primary mr-1"></i>
              Từ ngày
            </label>
            <input type="date" class="form-control" v-model="filter.fromDate" />
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6">
            <label class="form-label fw-bold">
              <i class="bi bi-calendar-event text-primary mr-1"></i>
              Đến ngày
            </label>
            <input type="date" class="form-control" v-model="filter.toDate" />
          </div>

          <div class="col-xl-6 col-lg-4 col-md-12">
            <div class="d-flex gap-2">
              <b-button variant="primary" @click="searchReport" class="px-4">
                <i class="bi bi-search mr-2"></i>
                Tìm kiếm
              </b-button>
              <b-button variant="outline-secondary" @click="resetFilter" class="px-4">
                <i class="bi bi-arrow-clockwise mr-2"></i>
                Đặt lại
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <!-- REPORT -->
      <div v-if="report">
        <!-- EMPLOYEE -->
        <div class="employee-card mb-4">
          <div class="employee-card-icon">
            <i class="bi bi-person-fill"></i>
          </div>
          <div class="d-flex align-items-center">
            <div class="avatar-circle mr-3">
              {{ report.fullName.charAt(0).toUpperCase() }}
            </div>
            <div>
              <h4 class="employee-name mb-0">{{ report.fullName }}</h4>
              <p class="employee-subtitle mb-0">Nhân viên Sale</p>
            </div>
          </div>
        </div>

        <!-- MAIN STATS -->
        <div class="stats-grid mb-4">
          <div class="stat-card stat-primary">
            <div class="stat-icon">
              <i class="bi bi-list-check"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ report.totalTasks }}</div>
              <div class="stat-label">Tổng task đã gọi</div>
            </div>
            <div class="stat-decoration"></div>
          </div>

          <div class="stat-card stat-success">
            <div class="stat-icon">
              <i class="bi bi-check-circle-fill"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ report.accepted }}</div>
              <div class="stat-label">Đồng ý</div>
            </div>
            <div class="stat-decoration"></div>
          </div>

          <div class="stat-card stat-danger">
            <div class="stat-icon">
              <i class="bi bi-x-circle-fill"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ report.rejected }}</div>
              <div class="stat-label">Từ chối</div>
            </div>
            <div class="stat-decoration"></div>
          </div>

          <div class="stat-card stat-info">
            <div class="stat-icon">
              <i class="bi bi-graph-up-arrow"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ report.convertRatio }}%</div>
              <div class="stat-label">Tỷ lệ chuyển đổi</div>
            </div>
            <div class="stat-decoration"></div>
          </div>
        </div>

        <!-- DETAIL STATS -->
        <div class="stats-grid">
          <div class="stat-card stat-warning">
            <div class="stat-icon">
              <i class="bi bi-telephone-x-fill"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ report.noAnswer }}</div>
              <div class="stat-label">Không bắt máy</div>
            </div>
            <div class="stat-decoration"></div>
          </div>

          <div class="stat-card stat-secondary">
            <div class="stat-icon">
              <i class="fa fa-ban"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ report.notCatch }}</div>
              <div class="stat-label">Thuê bao</div>
            </div>
            <div class="stat-decoration"></div>
          </div>

          <div class="stat-card stat-purple">
            <div class="stat-icon">
              <i class="bi bi-chat-left-dots-fill"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ report.consultationNeeded }}</div>
              <div class="stat-label">Cần tư vấn thêm</div>
            </div>
            <div class="stat-decoration"></div>
          </div>

          <div class="stat-card stat-teal">
            <div class="stat-icon">
              <i class="bi bi-cart-check-fill"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ report.ordered }}</div>
              <div class="stat-label">Khách đặt đơn</div>
            </div>
            <div class="stat-decoration"></div>
          </div>
        </div>
      </div>

      <!-- EMPTY -->
      <div v-else class="empty-state">
        <div class="empty-icon">
          <i class="bi bi-file-earmark-text"></i>
        </div>
        <h4 class="mt-3 mb-2">Không có dữ liệu</h4>
        <p class="text-muted">Vui lòng chọn khoảng thời gian để xem báo cáo</p>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios'

export default {
  data() {
    return {
      filter: {
        fromDate: '',
        toDate: ''
      },
      report: null
    }
  },

  mounted() {
    this.getReport()
  },

  methods: {
    async getReport() {
      try {
        const res = await apiClient.get('/api/v1/sale/report', {
          params: {
            fromDate: this.filter.fromDate || undefined,
            toDate: this.filter.toDate || undefined
          }
        })

        if (res?.data) {
          this.report = {
            fullName: res.data.full_name,
            totalTasks: res.data.total_tasks,
            accepted: res.data.accepted,
            rejected: res.data.rejected,
            noAnswer: res.data.no_answer,
            notCatch: res.data.not_catch,
            consultationNeeded: res.data.consultation_needed,
            convertRatio: res.data.convert_ratio,
            ordered: res.data.ordered
          }
        } else {
          this.report = null
        }
      } catch (e) {
        console.error('Sale report error', e)
        this.report = null
      }
    },

    searchReport() {
      this.getReport()
    },

    resetFilter() {
      this.filter = { fromDate: '', toDate: '' }
      this.getReport()
    },

    backToDashboard() {
      this.$router.replace('/sale')
    }
  }
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.0/font/bootstrap-icons.css');

.history {
  min-height: 100vh;
  padding: 30px 20px;
}

.report-container {
  max-width: 1400px;
}

.filter-card {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.form-label {
  font-size: 14px;
  color: #495057;
  margin-bottom: 8px;
}

.form-control {
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.employee-card {
  position: relative;
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.employee-card-icon {
  position: absolute;
  right: 24px;
  top: 24px;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.15;
}

.employee-card-icon i {
  font-size: 28px;
  color: white;
}

.avatar-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}

.employee-name {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
}

.employee-subtitle {
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.stat-card {
  position: relative;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 16px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.stat-decoration {
  position: absolute;
  right: -20px;
  top: -20px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  opacity: 0.1;
  transition: all 0.3s ease;
}

.stat-card:hover .stat-decoration {
  transform: scale(1.2);
  opacity: 0.15;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.stat-card:hover .stat-icon {
  transform: scale(1.1) rotate(5deg);
}

.stat-content {
  flex: 1;
  min-width: 0;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 4px;
  color: #2c3e50;
}

.stat-label {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
  line-height: 1.4;
  margin: 0;
}

.stat-primary .stat-icon {
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
}
.stat-primary .stat-decoration {
  background: #0d6efd;
}

.stat-success .stat-icon {
  background: linear-gradient(135deg, #20c997 0%, #17a589 100%);
}
.stat-success .stat-decoration {
  background: #20c997;
}

.stat-danger .stat-icon {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
}
.stat-danger .stat-decoration {
  background: #dc3545;
}

.stat-info .stat-icon {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
}
.stat-info .stat-decoration {
  background: #17a2b8;
}

.stat-warning .stat-icon {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
}
.stat-warning .stat-decoration {
  background: #ffc107;
}

.stat-secondary .stat-icon {
  background: linear-gradient(135deg, #6c757d 0%, #545b62 100%);
}
.stat-secondary .stat-decoration {
  background: #6c757d;
}

.stat-purple .stat-icon {
  background: linear-gradient(135deg, #6f42c1 0%, #5a32a3 100%);
}
.stat-purple .stat-decoration {
  background: #6f42c1;
}

.stat-teal .stat-icon {
  background: linear-gradient(135deg, #adb5bd 0%, #868e96 100%);
}
.stat-teal .stat-decoration {
  background: #adb5bd;
}

.empty-state {
  background: white;
  padding: 80px 20px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #f8f9fa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: #adb5bd;
}

.mr-1 { margin-right: 4px; }
.mr-2 { margin-right: 8px; }
.mr-3 { margin-right: 12px; }
.mb-0 { margin-bottom: 0; }
.mb-2 { margin-bottom: 8px; }
.mb-3 { margin-bottom: 1rem; }
.mb-4 { margin-bottom: 1.5rem; }
.mt-3 { margin-top: 1rem; }
.fw-bold { font-weight: 700; }
.text-muted { color: #6c757d; }
.text-primary { color: #0d6efd; }

@media (max-width: 1200px) {
  .stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
}

@media (max-width: 768px) {
  .history {
    padding: 20px 12px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .stat-card {
    padding: 20px;
  }

  .stat-value {
    font-size: 28px;
  }

  .header-title {
    font-size: 24px;
  }

  .header-icon {
    width: 48px;
    height: 48px;
  }

  .header-icon i {
    font-size: 24px;
  }
}

@media (max-width: 576px) {
  .stat-card {
    padding: 16px;
  }

  .avatar-circle {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

  .employee-name {
    font-size: 18px;
  }
}
</style>
